import React, { PureComponent } from "react";
import { Redirect } from "react-router";
import * as myConstClass from "../../constant.js";
import $ from "jquery";
import { toastr } from "react-redux-toastr";
import {
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

const image = `https://workzonepro.workzoneplus.com/backend/img/Work-Zone-Plus-logo.png`;
const image2 = `https://workzonepro.workzoneplus.com/backend/img/clock.png`;

// const {logout} = props.location.state;
class LogInForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      form: "1",
      showPassword: false,
      toDashboard: false,
      timeOut: 5000,
      showCloseButton: true,
      progressBar: true,
      position: "top-right",
      submitted: false,
    };
    // this.login = this.login.bind(this);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  tick() {
    //alert(this.state.code);  alert(this.state.interval_dynamic);
    if (this.state.code && this.state.interval_dynamic == "2") {
      fetch(
        myConstClass.LOGIN_URL +
          `user/getqrscan/` +
          this.state.code +
          "/" +
          this.state.tenant_id
      )
        .then((response) => response.json())
        .then((response) => {
          if (response) {
            //  this.setState({ form:0});
            this.setState({ code: response.org_code });
            this.setState({ tenent_id: response.tenant_id });
            this.setState({ interval_dynamic: response.interval_dynamic });
            this.setState({ form: 0 });
            this.setState({ qrcode: response.qrimage });
            this.setState({ title: response.title });
            // this.setState({ title:response.title});
          }
        })
        .catch();
    }
  }

  componentDidMount() {
    // localStorage.setItem('forget', '0');
    // window.location.href = '/';
    $(".main").css("background-image", "none");
    $(".main").css("background-size", "none");
    //alert('hii');
    // if(this.state.interval_dynamic=='2')
    // {
    this.interval = setInterval(() => this.tick(), 30000);
    // }
  }
  onFormCancel = () => {
    localStorage.setItem("custom", "0");
    window.location.href = "/";
  };
  onFormSubmit = () => {
    this.setState({ submitted: true }, () => {
      setTimeout(() => this.setState({ submitted: false }), 5000);

      fetch(myConstClass.BASE_URL + `login/verifyLogin/`, {
        method: "POST",
        body: JSON.stringify($("#pform").serializeArray()),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response == 2) {
            toastr.error("Error", "Please enter email..!", this.options);
          } else if (response == 3) {
            toastr.error("Error", "Please enter password ..!", this.options);
          } else if (response == 4) {
            toastr.error("Error", "Login Failed ...!", this.options);
          } else if (response !== false) {
            $(".main").css("background-image", "none");
            $(".main").css("background-size", "none");
            var sarray = response.split("-");
            localStorage.setItem("login_type", sarray["8"]);
            localStorage.setItem("role_modules", sarray["9"]);
            localStorage.setItem("manage_app", sarray["6"]);
            localStorage.setItem("login_id", sarray["7"]);
            localStorage.setItem("package", sarray["4"]);
            localStorage.setItem("manage_promotions", sarray["3"]);
            localStorage.setItem("uname", sarray["2"]);
            localStorage.setItem("utype", sarray["1"]);
            localStorage.setItem("session_id", sarray["0"]);
            localStorage.setItem("company_name", sarray["10"]);
            localStorage.setItem("departementhead", sarray["11"]);
            localStorage.setItem("is_subadmin", sarray["12"]);
            localStorage.setItem("sub_admin_role", sarray["13"]);

            localStorage.setItem("sub_admin_roles", sarray["14"]);

            localStorage.setItem("is_super_user", sarray["15"]);
            localStorage.setItem("hr_admin_roles", sarray["16"]);
            //alert();
            localStorage.setItem("is_google_transaltor", sarray["17"]);
            if (sarray["18"]) {
              localStorage.setItem("lang", sarray["18"]);
            } else {
              localStorage.setItem("lang", "en");
            }
            //localStorage.setItem('is_payroll_privilage', sarray['19']);
            //  alert(sarray['19']);
            localStorage.setItem("org_id_payroll", sarray["20"]);
            if (sarray["19"] != undefined) {
              var payroll_pri = sarray["19"].split("_");
              localStorage.setItem("is_payroll_privilage", "1");
              localStorage.setItem("empapprovepayroll", payroll_pri["0"]);
              localStorage.setItem("empapprovepaid", payroll_pri["1"]);
              localStorage.setItem("emppayline", payroll_pri["2"]);
            } else {
              localStorage.setItem("is_payroll_privilage", "0");
              localStorage.setItem("empapprovepayroll", "0");
              localStorage.setItem("empapprovepaid", "0");
              localStorage.setItem("emppayline", "0");
            }
            var admin_id = localStorage.getItem("uname");
            var login_id = localStorage.getItem("login_id");

            //	  alert(storedNames);
            var admin_id = localStorage.getItem("uname");
            // alert(admin_id);
            var login_type = localStorage.getItem("login_type");
            var login_id = localStorage.getItem("login_id");
            fetch(
              myConstClass.BASE_URL +
                "user/getunreadMessagesCount/" +
                admin_id +
                "/" +
                login_id +
                "/" +
                login_type
            )
              .then((response) => response.json())
              .then((response) => {
                //const notifications = [];
                //this.setState({leave_types: response})

                //alert(response);
                //alert(response);

                localStorage.setItem("mcount", response);
                //alert(mcount);
                /*    toastr.info(
                                  'Message',
                                  "You have a new message",
                                  this.options
                                ) */
              })
              .catch((err) => console.log(err));

            fetch(
              myConstClass.BASE_URL +
                "user/getunreadOrderCount/" +
                admin_id +
                "/" +
                login_type
            )
              .then((response) => response.json())
              .then((response) => {
                //const notifications = [];
                //this.setState({leave_types: response})

                //alert(response);
                //alert(response);

                localStorage.setItem("ocount", response);
                //alert(mcount);
                /*    toastr.info(
                                  'Message',
                                  "You have a new message",
                                  this.options
                                ) */
              })
              .catch((err) => console.log(err));

            // alert(mcount);
            // alert(mcount);

            this.setState(() => ({
              toDashboard: true,
            }));
          }
        })
        .catch();
    });
  };

  render() {
    const { formData, submitted } = this.state;
    if (this.state.toDashboard === true) {
      window.location.href = "/dashboard";
      return <Redirect to="/dashboard" />;
    }
    return (
      <React.Fragment>
        <div className="text-center mt-4">
          {/* <h1 className="h2">Reset password</h1> */}
        </div>
        <Card>
          <CardBody>
            <div className="m-sm-4">
              <div
                style={
                  this.state.form == "1"
                    ? { display: "block" }
                    : { display: "none" }
                }
              >
                <div className="text-center">
                  {/* <img src={image2} style={{'width':'40px','height':'40px'}}></img> */}
                  <img
                    src={image2}
                    style={{ width: "40px", height: "40px;" }}
                  ></img>
                  <img
                    src={image}
                    style={{ width: "250px", height: "38px;" }}
                  ></img>
                </div>
                <br />
                <br />
                <p className="lead">Enter your username for custom report</p>
                <Form className="form" id="pform" onSubmit={this.onFormSubmit}>
                  <FormGroup>
                    <Label>username</Label>
                    <Input
                      bsSize="lg"
                      type="text"
                      id="code"
                      name="code"
                      placeholder="Enter your Username"
                    />
                    <br />
                    <Label>Password</Label>
                    <Input
                      bsSize="lg"
                      type="password"
                      name="password"
                      placeholder="Enter your Password"
                    />

                    <Input
                      style={{ display: "none" }}
                      value="1"
                     
                      name="custom"
                     
                    />
                  </FormGroup>
                  {/* <Link to="auth/reset"></Link> */}
                  {/* <small>
                <Link to="/auth/reset">Forgot password?</Link>
              </small> */}
                  <div className="text-center mt-3">
                    {/* <Link to="/dashboard"> 
               <Button color="primary" size="lg"  onSubmit={this.onFormSubmit}>               
               Sign in
             </Button>  
              </Link> */}
                    {/* <a href="http://localhost:3000/dashboard" > 
              <Button color="primary" size="lg"  onSubmit={this.onFormSubmit}>               
               Sign in
             </Button>        
           </a> */}
                  </div>
                  {/* <a href="<?=site_url('user_verification? email=' . $email );?> ">Click To Verifiy Email </a> */}

                  <div className="text-center mt-3">
                    {/* <a href="<?=site_url('user_verification?email=' . $email );?> ">Click To Verifiy Email </a> */}

                    {/* <Link to="auth/reset"> */}
                    <Button
                      color="primary"
                      style={{ margin: "0rem 1.50rem 0rem 0rem" }}
                      size="lg"
                      onClick={this.onFormSubmit}
                    >
                      submit
                    </Button>
                    <Button
                      color="primary"
                      size="lg"
                      onClick={this.onFormCancel}
                    >
                      Cancel
                    </Button>
                    {/* <Link to={'/' + myConstClass.TENANT_PAGE_PATH + "attendance/listing"} style={{ margin: "0rem 1.50rem 1.50rem 0rem", border: "#6f42c1 1px solid", color: "#6f42c1", padding: "0.10rem 0.90rem 0.30rem 0.90rem", textDecoration: 'none', borderRadius: '0.2rem' }}>{T("Cancel")}</Link> */}

                    {/* <Button disabled={submitted}>{
                              (submitted && 'Your form is submitted!')
                              || (!submitted && 'Submit')
                          }</Button> */}
                    {/* </Link> */}
                  </div>

                  {/* <center><img src={image3} style={{'width':'40%'}}></img><br/>    */}
                  {/* <p><a href="https://www.epenh.com" target="_blank">Developed by Epenh Co. Ltd © 2019</a></p></center> */}
                </Form>
              </div>
            </div>

            <div
              className="text-center"
              style={
                this.state.form == "0"
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              {/* <img src={image2} style={{'width':'40px','height':'40px'}}></img> */}
              {/* <img src={image2} style={{ 'width': '40px', 'height': '40px;' }} ></img>
                <img src={image} style={{ 'width': '250px', 'height': '38px;' }}></img> */}
              <p className="lead" style={{ fontWeight: "bold" }}>
                Organization Name:{this.state.title}
              </p>
              <img
                src={this.state.qrcode}
                style={{ height: "500px", width: "500px" }}
              />
              <br />
              <Button color="primary" size="lg" onClick={this.onFormCancel}>
                Go to Login
              </Button>
            </div>
          </CardBody>
        </Card>
        {/* <center><img src={image3} style={{'width':'35%'}}></img><br/>   
       <p><a href="https://www.epenh.com" target="_blank">Developed by Epenh Co. Ltd © 2019</a></p></center> */}
      </React.Fragment>
    );
  }
}

export default LogInForm;
